import React from 'react';

import SRF_Logo from "./SRF_Logo.svg";
const Header = ({appTitle}) => {

  return (
    // <header className="bg-primary py-4 text-white flex justify-between">
    //     <a href="https://rigid.quickbase.com/nav/app/bucbxyva3/" className='flex flex-col text-center'>
    //         <img className="h-8 ml-4" src={SRF_Logo} alt="SRF LOGO" />
    //     <h1 className="text-xl font-semibold">{appTitle}</h1>
    //     </a>
    //   <div>
    //     <p className="mt-2">Manage your {appTitle} with ease.</p>
    //   </div>
    // </header>

    <header className="bg-primary py-4 text-white flex md:flex-row flex-col md:justify-between justify-center shadow-lg z-50">
    <div className='flex flex-col text-center'>
      <img className="h-8 ml-4 shadow-md" src={SRF_Logo} alt="SRF LOGO" />
      <    h1 className="text-xl drop-shadow-md col text-slate-50">{appTitle}</h1>
    </div>
    {/* <h3 className='text-white text-xl flex-col justify-center text-center mx-5 md:flex hidden '>Field Reports</h3> */}
    <div className='flex-col justify-center items-center mx-5 md:flex hidden '>
    <img className="h-8 ml-4 shadow-md" src="https://saferightfast.app/images/b150448c-ab84-45f5-4abe-48e9cf758c00/tes.png" alt="SRF LOGO" />
    </div>
  </header>
  );
};

export default Header;
